/**
     * @desc 移除参会人、参会设备
可能产生业务错误码：510001、511001、511005
     */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {
  /** 云信会议房间ID */
  channelId?: number;
  /** 是否禁止再加入会议 */
  forbidReenter?: boolean;
  /** 被移除的参会设备ID */
  removedMemberDeviceId?: string;
  /** 被移除的参会人uid */
  removedMemberUid?: string;
}

export const method = 'DELETE';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey('/api/bs-vmeeting/v3/member/remove', params, 'DELETE'),
    newValue,
    shouldRevalidate,
  );
}

export function useDeprecatedRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/v3/member/remove',
    params,
    swrOptions,
    { method: 'DELETE' },
  );
}

export function request(params: Params, options?: any) {
  return PontCore.fetch(
    PontCore.getUrl('/api/bs-vmeeting/v3/member/remove', params, 'DELETE'),
    {
      method: 'DELETE',

      ...options,
    },
  );
}
